import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { saveContactUSForm } from '../../../utils/APIs';
import Loader from '../../../components/UI/Loader/Loader';
import { useUserContext } from '../../../contexts/UserContext';
import Dropdown from '../../../components/UI/Dropdown/Dropdown';
import Button from '../../../components/UI/Button';
import Card from '../../../components/UI/Card';
import { Textarea } from '../../../components/UI';
import { useContentfulContext } from '../../../contexts/ContentfulContext';
import { Mail, Send } from 'lucide-react';

const ContactUS = () => {
    const { userData } = useUserContext();
    const { content } = useContentfulContext();
    const [loading, setLoading] = useState(false);
    const [description, setDescription] = useState("");
    const [selectedCategory, setSelectedCategory] = useState("");
    const [errors, setErrors] = useState({});

    const validateForm = () => {
        const newErrors = {};
        if (!selectedCategory) newErrors.category = content?.CONTACT_US_SIDE_MENU_CONTENT?.errors?.EF131 || "Please select a category";
        if (!description.trim()) newErrors.description = content?.CONTACT_US_SIDE_MENU_CONTENT?.errors?.EF132 || "Please provide a description";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleOnChangeCategory = (val) => {
        setSelectedCategory(val.id);
        if (errors.category) {
            setErrors(prev => ({ ...prev, category: undefined }));
        }
    };

    const handleOnChangeDescription = (e) => {
        setDescription(e.target.value);
        if (errors.description) {
            setErrors(prev => ({ ...prev, description: undefined }));
        }
    };

    const handleSubmit = async () => {
        if (!validateForm()) return;

        try {
            setLoading(true);
            const data = { 
                description, 
                category: selectedCategory, 
                organization_id: userData?.selectedOrganization?.org_token,
                organisation_name: userData?.selectedOrganization?.name,
            };
            const result = await saveContactUSForm(userData?.token, data);
            toast.success(result.message || "Message sent successfully!");
            setDescription("");
            setSelectedCategory("");
            setErrors({});
        } catch (error) {
            toast.error(error?.message || content?.COMMON_MESSAGE?.something_wrong_msg || "Failed to submit request");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="stride-page-shell">
            {loading && <Loader />}
            <div className="max-w-2xl space-y-6">
                <div>
                    <span className="stride-eyebrow">Support & Feedback</span>
                    <h1 className="text-2xl font-bold tracking-tight text-stride-heading mt-0.5">
                        {content?.CONTACT_US_SIDE_MENU_CONTENT?.title || "Contact Us"}
                    </h1>
                    <p className="text-sm text-stride-body mt-1">
                        {content?.CONTACT_US_SIDE_MENU_CONTENT?.page_description || "Get in touch with the support team for inquiries, feedback, or assistance."}
                    </p>
                </div>

                <Card className="space-y-6">
                    <div>
                        <label className="block text-sm font-semibold text-stride-heading mb-1.5">
                            {content?.CONTACT_US_SIDE_MENU_CONTENT?.category || "Category"}
                        </label>
                        <Dropdown
                            items={content?.CONTACT_US_SIDE_MENU_CONTENT?.categories || []}
                            callback={handleOnChangeCategory}
                        />
                        {errors.category && <p className="mt-1.5 text-xs text-stride-danger">{errors.category}</p>}
                    </div>

                    <div>
                        <Textarea
                            label={content?.CONTACT_US_SIDE_MENU_CONTENT?.description || "Description"}
                            rows={6}
                            value={description}
                            placeholder={content?.CONTACT_US_SIDE_MENU_CONTENT?.description_placeholder || "How can we assist you today?"}
                            onChange={handleOnChangeDescription}
                            error={errors.description}
                        />
                    </div>

                    <div className="flex justify-end pt-2">
                        <Button
                            variant="primary"
                            icon={<Send size={15} />}
                            onClick={handleSubmit}
                            loading={loading}
                        >
                            {content?.CONTACT_US_SIDE_MENU_CONTENT?.submit || "Submit Request"}
                        </Button>
                    </div>
                </Card>
            </div>
        </div>
    );
};

export default ContactUS;
